import { render, staticRenderFns } from "./RoleBind.vue?vue&type=template&id=5e58c8e8&scoped=true"
import script from "./RoleBind.vue?vue&type=script&lang=js"
export * from "./RoleBind.vue?vue&type=script&lang=js"
import style0 from "./RoleBind.vue?vue&type=style&index=0&id=5e58c8e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e58c8e8",
  null
  
)

export default component.exports